/**
 * @generated SignedSource<<e53d0722e6f0767a510a216aaa7eb564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeConditionOperator = "EQUALS" | "EXISTS" | "%future added value";
export type MailingListType = "DYNAMIC" | "STATIC" | "%future added value";
export type CreateMailingListInput = {
  criterion?: MembershipCriterionInput | null | undefined;
  description?: string | null | undefined;
  name: string;
  type?: MailingListType | null | undefined;
};
export type MembershipCriterionInput = {
  conditions: ReadonlyArray<AttributeConditionInput>;
};
export type AttributeConditionInput = {
  attributeName: string;
  operator: AttributeConditionOperator;
  value?: string | null | undefined;
};
export type CreateMailingListDialogMutation$variables = {
  input: CreateMailingListInput;
};
export type CreateMailingListDialogMutation$data = {
  readonly createMailingList: {
    readonly id: string;
    readonly name: string;
  };
};
export type CreateMailingListDialogMutation = {
  response: CreateMailingListDialogMutation$data;
  variables: CreateMailingListDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "createMailingList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMailingListDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMailingListDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "34ab3a4eeb26fca0bebb99c3ba139eb9",
    "id": null,
    "metadata": {},
    "name": "CreateMailingListDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMailingListDialogMutation(\n  $input: CreateMailingListInput!\n) {\n  createMailingList(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "160cf91bb51e6b6fd3edb9a9e4d2894e";

export default node;
